// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2v86S","label":"Labeled_label__1afDK","divider":"Labeled_divider__2ypJ-"};